import {Model} from "@tailflow/laravel-orion/lib/model";

export default class Resort extends Model<{}> {
    public $resource(): string {
        return "resorts";
    }

    public $getKeyName() : string {
        return 'uuid';
    }
}